// File: src/components/about/AboutHero.js

import React, { useEffect, useRef } from 'react';
import { ASSETS_BASE_URL } from '../../config/constants';
import styles from './AboutHero.module.css';

const ABOUT_VIDEO_URL = `${ASSETS_BASE_URL}/greenscience-about-bg.mov`;

function AboutHero() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const playVideo = () => {
      video.play().catch(() => {});
    };

    if (video.readyState >= 3) {
      playVideo();
    } else {
      video.addEventListener('loadeddata', playVideo);
    }

    return () => {
      video.removeEventListener('loadeddata', playVideo);
    };
  }, []);

  return (
    <section className={styles.hero}>
      <div className={styles.card}>

        {/* ── Video layer ── */}
        <div className={styles.videoBg}>
          <video
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            className={styles.video}
            preload="auto"
          >
            <source src={ABOUT_VIDEO_URL} type="video/mp4" />
          </video>
          <div className={styles.overlay} />
        </div>

        {/* ── Content ── */}
        <div className={styles.content}>
          <div className={styles.textBlock}>

            <div className={styles.titleBlock}>
              <h1 className={styles.title}>
                <span className={styles.lineWhite}>Built on Science.</span>
                <span className={styles.lineGreen}>Driven by Purpose.</span>
              </h1>
            </div>

            <div className={styles.rule} aria-hidden="true" />

            <p className={styles.body}>
              GreenScience was founded on a simple but radical idea — that
              organic waste is not a problem to be buried, but a resource
              waiting to be unlocked.
            </p>

          </div>
        </div>

      </div>
    </section>
  );
}

export default AboutHero;